module.exports = {"login":"LOGIN","account":"Account","pwd":"Password","accountRequiredMsg":"Please input account name","pwdRequiredMsg":"Please input your password","errorMsg1012":"Account name not found","errorMsg9000":"Password is incorrect","errorMsg9001":"Login method incorrect","reset_password":"You need change your password","sso_login":"Switch to SSO login"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US-login.json
// module id = 599
// module chunks = 21